/** @file Renames the project. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';
import { names } from '@pose2d/format/names';

export const command = defineCommand({
  name: 'project.rename',
  description: 'Rename the project (ASCII name; it becomes the export file name).',
  input: z.object({ name: z.string().regex(names.RE) }).strict(),
  apply(draft, input, ctx) {
    draft.meta.name = input.name;
    draft.meta.updatedAt = ctx.now;
  },
});
